export type { LiveChatAppSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";

export enum LiveChatAppAccountMenuTab {
  install = "install",
  generalInfo = "generalInfo",
  chatStarter = "chatStarter",
  customButton = "customButton",
  quickActions = "quickActions",
}
